module.exports = __webpack_public_path__ + "static/img/desktop-rygl.0d5ba9ff.png";